import { setMixpanelSuperProperties } from "utils";

export function trackClaimsInfo(userClaimsList) {
  if (!userClaimsList) return;

  // Mixpanel
  const { ClaimsTrackerInfo, ClaimsInfo, SubmissionsInfo } = userClaimsList;
  const numberOfClaims = ClaimsInfo?.length ?? 0;
  const numberOfClaimSubmitted = SubmissionsInfo?.length ?? 0;
  let activeClaims = 0;
  let pastClaims: number;
  let submissionNumbers: string[] = [];
  let claimsSource = "None";

  // Claims and FNOL submissions are combined in ClaimsTrackerInfo results but separate keys otherwise
  if (ClaimsTrackerInfo) {
    claimsSource = "ClaimsTrackerInfo";
    activeClaims = ClaimsTrackerInfo.filter(
      ({ Status }) => Status === "Open",
    ).length;

    pastClaims = ClaimsTrackerInfo.length - activeClaims;
  } else {
    if (ClaimsInfo) {
      claimsSource = "ClaimsInfo";
      submissionNumbers = ClaimsInfo.map((claim) => claim.SubmissionNumber);

      activeClaims += ClaimsInfo.filter(
        ({ Status }) => Status === "Open",
      ).length;
    }

    if (SubmissionsInfo) {
      claimsSource += "SubmissionInfo";
      activeClaims += SubmissionsInfo.filter((submission) => {
        return !submissionNumbers.includes(submission.SubmissionNumber);
      }).length;
    }

    pastClaims = numberOfClaims + numberOfClaimSubmitted - activeClaims;
  }

  setMixpanelSuperProperties({
    numberOfClaims,
    numberOfClaimSubmitted,
    activeClaims,
    pastClaims,
    claimsSource,
  });

  // Qualtrics
  const claimNumbers = ClaimsTrackerInfo?.map((claim) => {
    const { CarrierClaim, FNOLSubmission } = claim;
    return CarrierClaim?.Number ?? FNOLSubmission?.SubmissionNumber;
  }).join(", ");

  // Set Qualtrics claims data
  window.SURVEY_CLAIMS_TRACKER_FLAG = !ClaimsInfo;
  window.SURVEY_CLAIMS_COUNT = ClaimsInfo?.length ?? ClaimsTrackerInfo?.length;
  window.SURVEY_USER_CLAIM_NUMBERS = claimNumbers;
}
